export default __webpack_public_path__ + "static/media/picto_1.07e8a1d9.png";